import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface SettingsStore {
	sidebarCollapse: boolean;
}

export const INITIAL_STATE: SettingsStore = {
	sidebarCollapse: false,
};

export const useSettingsStore = create(
	persist(
		() => ({
			...(INITIAL_STATE as SettingsStore),
		}),
		{
			name: "settings", // name of the item in the storage (must be unique)
		},
	),
);
